const variantsContent = document.getElementById("variantsContent");

function linkedVariants() {
  variantsContent.classList.toggle("show");
}

document.addEventListener("click", (event) => {
  if (!event.target.matches(".linked_variants--select") && variantsContent.classList.contains("show")) {
    variantsContent.classList.remove("show");
    
    const dropdowns = document.getElementsByClassName("variants-dropdown-content");
    for (let dropdown of dropdowns) {
      if (dropdown.classList.contains("show")) {
        dropdown.classList.remove("show");
      }
    }
  }
});
